import axios from "axios";
import React, { useEffect, useState } from "react";
import { api } from "../utils/Api";
import Layout from "../layout/Layout";
import { CustomSpinner } from "../utils/CustomComponents";
import { Flex, notification, Button } from "antd";
import CardsPercentageLoad from "./CardsPercentageLoad";
import PlantType from "./PlantType";
import JobSiteType from "./JobSiteType";
import { RollbackOutlined } from "@ant-design/icons";

const PouredLoadDetails = ({ match, history }) => {
	const [loading, setLoading] = useState(true);
	const [load, setLoad] = useState({});
	const [type, setType] = useState("plant");
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	useEffect(() => {
		getLoad();
	}, []);

	const getLoad = async () => {
		try {
			setLoading(true);

			const url = api + `/load/pouring/57Concrete/get/${match.params.id}`;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.get(url);
			if (data.success) {
				setLoad(data.payload);
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoading(false);
		} catch (err) {
			console.error(err.message);
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	const RenderSections = () => {
		return (
			<Flex vertical gap={16}>
				<CardsPercentageLoad load={load} action={setType} type={type} />
				{type === "plant" && <PlantType load={load} />}
				{type === "jobsite" && <JobSiteType load={load} />}
			</Flex>
		);
	};

	const goBack = () => {
		history.goBack();
	};

	return (
		<Layout title="Load Details" description="">
			<Flex vertical gap={16}>
				<Button
					type="primary"
					size="large"
					icon={<RollbackOutlined />}
					onClick={goBack}
					loading={loading}
					disabled={loading}
				/>
				{loading ? <CustomSpinner /> : <RenderSections />}
				{contextHolder}
			</Flex>
		</Layout>
	);
};

export default PouredLoadDetails;
